@let lloydsRoadmapValue = lloydsRoadmap();
@for (page of pages(); track $index) {
  <cfp-report-page
    [portfolioTitle]="customerName()"
    [translationKeyPrefix]="'lbgPortfolioRoadmapReport'"
    [headerLogo]="headerLogo()"
    [chromeFooter]="chromeFooter()"
  >
    <h1>{{ customerName() }}</h1>
    @if ($index === 0) {
      <div class="row mb-5 align-items-stretch">
        <div class="col-6">
          <cfp-card
            [fullHeight]="true"
            [title]="'portfolioBuildingsRoadmapReport.summary' | translate"
            [useH1]="true"
          >
            <cfp-info-list>
              <div
                cfpInfoListItem
                [label]="'lbgPortfolioRoadmapReport.buildings.numberOfBuildings' | translate"
                [icon]="'building'"
              >
                {{ lloydsRoadmapValue.businessCase.numberOfBuildings | number: '1.0-0' }}
              </div>
              <div
                cfpInfoListItem
                [label]="'portfolioBuildingsRoadmapReport.businessCase.costReduction' | translate"
                [icon]="environment.icons.iconSavings"
              >
                {{ lloydsRoadmapValue.businessCase.totalCostReduction | cfpCurrency: lloydsRoadmapValue.currencyCode }}
              </div>
              <div
                cfpInfoListItem
                [label]="'portfolioBuildingsRoadmapReport.businessCase.investment' | translate"
                [icon]="environment.icons.iconSubsidy"
              >
                {{ lloydsRoadmapValue.businessCase.totalInvestment | cfpCurrency: lloydsRoadmapValue.currencyCode }}
              </div>
              <div
                cfpInfoListItem
                [label]="'lbgPortfolioRoadmapReport.businessCase.paybackPeriod' | translate"
                [icon]="environment.icons.iconReturnInvestment"
              >
                <span
                  [innerHtml]="
                    lloydsRoadmapValue.businessCase.paybackPeriodYears
                      | paybackPeriod
                        : lloydsRoadmapValue.businessCase.totalInvestment
                        : lloydsRoadmapValue.businessCase.totalCostReduction
                  "
                ></span>
              </div>
              <div
                cfpInfoListItem
                [label]="'portfolioBuildingsRoadmapReport.businessCase.co2ConsumptionReduction' | translate"
                [icon]="environment.icons.iconCo2Reduction"
              >
                {{ lloydsRoadmapValue.businessCase.co2ConsumptionReductionPercentage | number: '1.0-0' }}% (<span
                  [innerHtml]="lloydsRoadmapValue.businessCase.totalYearlyCo2ConsumptionReduction | co2: false"
                ></span
                >)
              </div>
              <div
                cfpInfoListItem
                [label]="'lbgPortfolioRoadmapReport.businessCase.co2IntensityReduction' | translate"
                [icon]="'file-chart-line'"
              >
                {{ lloydsRoadmapValue.businessCase.co2IntensityReductionPercentage | number: '1.0-0' }}% ({{
                  lloydsRoadmapValue.businessCase.co2IntensityReductionKgM2 | number: '1.0-0'
                }}
                kg/m²)
              </div>
              <div
                cfpInfoListItem
                [label]="'lbgPortfolioRoadmapReport.businessCase.greenLoanEligible' | translate"
                [icon]="'leaf'"
              >
                {{ lloydsRoadmapValue.businessCase.greenLoanEligible.percentage | number: '1.0-0' }}% ({{
                  lloydsRoadmapValue.businessCase.greenLoanEligible.numberOfBuildings | number: '1.0-0'
                }}
                {{ 'lbgPortfolioRoadmapReport.businessCase.buildings' | translate }})
              </div>
            </cfp-info-list>
          </cfp-card>
        </div>
        <div class="col-6">
          <div class="card card-map h-100">
            <div class="card-body p-0">
              <cfp-portfolio-locations-map
                class="d-flex w-100 h-100 flex-column"
                [moduleRoute]="'/energy'"
                [portfolioId]="portfolioId()"
                [showHeader]="false"
                [(fitBoundsEnabled)]="mapFitBoundsEnabled"
                (mapReadyForPrint)="mapReadyForPrint.emit($event)"
              />
            </div>
          </div>
        </div>
      </div>
    }
    <h2>
      {{
        ('buildings' | translate) +
          ($index > 0 ? ' (' + ('portfolioBuildingsRoadmapReport.continued' | translate) + ')' : '')
      }}
    </h2>
    @if ($index === 0) {
      <p>{{ 'lbgPortfolioRoadmapReport.buildings.description' | translate }}</p>
    }
    <cfp-lbg-report-buildings-table [buildings]="page" />
    <div class="row mt-4 g-4">
      <div class="col-auto d-flex justify-content-center align-items-center">
        <div class="energy-label energy-label-sm me-2">
          <cfp-energy-label-epc class="d-flex" [labelClass]="'legend'" [size]="'sm'" [energyLabel]="undefined" />
        </div>
        {{ 'portfolioBuildingsRoadmapReport.energyLabels.legend.calculated' | translate }}
      </div>
      <div class="col-auto d-flex justify-content-center align-items-center">
        <div class="energy-label energy-label-sm me-2">
          <cfp-energy-label-epc
            class="d-flex"
            [labelClass]="'legend'"
            [isRegistered]="true"
            [size]="'sm'"
            [energyLabel]="undefined"
          />
        </div>
        {{ 'portfolioBuildingsRoadmapReport.energyLabels.legend.registered' | translate }}
      </div>
      @if (hasCalculatedBetterLabels()) {
        <div class="col-auto d-flex justify-content-center align-items-center">
          <div class="energy-label energy-label-sm me-2">
            <cfp-energy-label-epc
              class="d-flex"
              [labelClass]="'legend'"
              [showCalculatedBetter]="true"
              [size]="'sm'"
              [energyLabel]="undefined"
            />
          </div>
          {{ 'portfolioBuildingsRoadmapReport.energyLabels.legend.calculatedBetter' | translate }}
        </div>
      }
      @if (hasExpiredLabels()) {
        <div class="col-auto d-flex justify-content-center align-items-center">
          <div class="energy-label energy-label-sm me-2">
            <cfp-energy-label-epc
              class="d-flex"
              [labelClass]="'legend'"
              [isRegistered]="true"
              [isRegisteredExpired]="true"
              [size]="'sm'"
              [energyLabel]="undefined"
            />
          </div>
          {{ 'portfolioBuildingsRoadmapReport.energyLabels.legend.expired' | translate }}
        </div>
      }
      @if (hasAlmostExpiredLabels()) {
        <div class="col-auto d-flex justify-content-center align-items-center">
          <div class="energy-label energy-label-sm me-2">
            <cfp-energy-label-epc
              class="d-flex"
              [labelClass]="'legend'"
              [isRegistered]="true"
              [isRegisteredAlmostExpired]="true"
              [size]="'sm'"
              [energyLabel]="undefined"
            />
          </div>
          {{ 'portfolioBuildingsRoadmapReport.energyLabels.legend.almostExpired' | translate }}
        </div>
      }
      @if (hasPlan()) {
        <div class="col-auto d-flex justify-content-center align-items-center">
          <cfp-badge [badgeStyle]="'secondary'" [classes]="'me-2'">
            {{ 'portfolioBuildingsRoadmapReport.plan' | translate }}
          </cfp-badge>
          {{ 'portfolioBuildingsRoadmapReport.energyLabels.legend.plan' | translate }}
        </div>
      }
      @if (hasGreenLoanEligible()) {
        <div class="col-auto d-flex justify-content-center align-items-center">
          <cfp-icon [icon]="'leaf'" [iconStyle]="'success'" [class]="'me-2'" />
          {{ 'lbgPortfolioRoadmapReport.energyLabels.legend.greenLoanEligible' | translate }}
        </div>
      }
    </div>
  </cfp-report-page>
}
